import { render, staticRenderFns } from "./CallToAction.vue?vue&type=template&id=2525165c"
import script from "./CallToAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallToAction.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CallToAction.vue?vue&type=style&index=0&id=2525165c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports